import { gql } from '@apollo/client';

export const REPORT = gql`
  fragment report on Report {
    id
    createdAt
    name
    reportType
    urlFile
    files {
      id
      url
    }
    reportCategory
    text
    status
    statusDate
  }
`;
